import { render, staticRenderFns } from "./arti_detail.vue?vue&type=template&id=1908ce86&scoped=true"
import script from "./arti_detail.vue?vue&type=script&lang=js"
export * from "./arti_detail.vue?vue&type=script&lang=js"
import style0 from "./arti_detail.vue?vue&type=style&index=0&id=1908ce86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1908ce86",
  null
  
)

export default component.exports